import { render, staticRenderFns } from "./fhir-extension.vue?vue&type=template&id=28ee29bb&"
import script from "./fhir-extension.vue?vue&type=script&lang=js&"
export * from "./fhir-extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports